import { useQuery, type UseQueryOptions } from "@tanstack/react-query";

import type { GetOrderCountRequestDto } from "../../dtos/get-order-count-request-dto";
import type { GetOrderCountResponseDto } from "../../dtos/get-order-count-response-dto";
import { OrderQueryKeys } from "../../generators/order-query-keys";
import { OrderService } from "../../services/order-service";

type UseGetOrderCountQueryParams = {
  queryParams?: GetOrderCountRequestDto;
  options?: Omit<UseQueryOptions<GetOrderCountResponseDto>, "queryKey">;
};

export const useGetOrderCountQuery = ({
  queryParams,
  options
}: UseGetOrderCountQueryParams = {}) => {
  return useQuery({
    queryKey: OrderQueryKeys.getOrderCount({ ...queryParams }).queryKey,
    queryFn: async () =>
      await OrderService.getOrderCount({ payload: queryParams ?? {} }),
    ...options
  });
};
